import "./index.css";

import { InfoveaveTheme } from "@infoveave/ui-components";
import { InfoveaveUIProvider } from "@infoveave/ui-primitives";
import { StrictMode, Suspense } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router";

import { RouteLoadingPage } from "./components/route-loading-page";
import { router } from "./router";

const root = document.querySelector<HTMLDivElement>("#root");
if (!root) throw new Error("Application root is missing.");

createRoot(root).render(
  <StrictMode>
    <InfoveaveUIProvider>
      <InfoveaveTheme>
        <Suspense fallback={<RouteLoadingPage />}>
          <RouterProvider router={router} />
        </Suspense>
      </InfoveaveTheme>
    </InfoveaveUIProvider>
  </StrictMode>
);
